import PropTypes from 'prop-types';
import React from 'react';
import Tag from 'components/forms/Tag';
import ConfirmationModal from 'components/modals/ConfirmationModal';
import * as Moment from 'moment';
import moment from 'moment-timezone';
import { getDiffInMinutes } from 'utils/misc';
import PeopleIcon from 'mdi-react/PeopleIcon';
import CalendarDayIcon from 'mdi-react/CalendarDayIcon';

const LaunchConfirmationModal = ({
  isOpen,
  toggle,
  launchDate,
  launchDateTz,
  totalContacts,
  onSave,
}) => {
  const diffInMinutes = getDiffInMinutes(launchDateTz);
  let launchDateWithDiff = new Date(moment(launchDate).add(-diffInMinutes, 'minutes'));
  launchDateWithDiff = Moment(launchDateWithDiff).format('MM/DD/YYYY hh:mm');

  return (
    <ConfirmationModal
      open={isOpen}
      onBackdropClick={toggle}
      title="Launch sequence"
      confirmLabel="Launch"
      onConfirmClick={() => onSave(true)}
      onCancelClick={toggle}
      confirmBtnColor="primary"
    >
      <div className="instance-form__header border-bottom-0">
        <h5>Sequence will launch to:</h5>
      </div>
      <div className="instance-form__body text-center">
        <h4><Tag color="primary" icon={<PeopleIcon />} label={`${totalContacts} contacts`} /></h4> on &nbsp;
        <h4>
          <Tag color="primary" label={`${launchDateWithDiff} ${launchDateTz}`} icon={<CalendarDayIcon />} />
        </h4>
        <p><b>Are you sure you would like to launch?</b></p>
      </div>
    </ConfirmationModal>
  );
};

LaunchConfirmationModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  launchDate: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.instanceOf(Date),
  ]).isRequired,
  launchDateTz: PropTypes.string.isRequired,
  totalContacts: PropTypes.number.isRequired,
  onSave: PropTypes.func.isRequired,
};

LaunchConfirmationModal.defaultProps = {
};

export default LaunchConfirmationModal;
